import styled from 'styled-components';
import {borderTop1px} from '../../../utils/style/mixin';

const ItemContainerBody = styled.div`
display: flex;
flex-direction: column;
width: 100%;
`;

const ItemContainer = styled.div`
display: flex;
flex-direction: row;
${borderTop1px({})};
width: 100%;
height: 2.5rem;
background-color: #fff;
z-index: 10;
padding: .2rem;
`;

const FoldComtainer = styled.div`
justify-content: space-between;
display: flex;
flex-direction: row;
align-items: center;
height: 1.28rem;
background: rgba(246,246,246,1);
z-index: 10;
margin: .2rem;
border-radius: .12rem;
padding-right: .2rem
`;

const FoldTitleComtainer = styled.div`
display: flex;
flex-direction: column;
align-items: center;
justify-content: space-around;
padding: .2rem
`;

const FoldMoreTitleComtainer = styled.div`
display: flex;
align-items: center;
justify-content: space-between;
padding: .2rem
`;

const FoldImgComtainer = styled.div`
width:4rem
display: flex;
justify-content: flex-start;
padding-left: .2rem
.img {
  max-width: 1rem;
  max-height: 1rem;
  margin-right: .24rem
}
`;

const FoldMoreContainer = styled.div`
display: flex;
flex-direction: row;
align-items: center;
height: 1.08rem;
background: rgba(246,246,246,1);
z-index: 10;
margin: .2rem;
justify-content: space-between;
border-radius: .12rem;
padding-right: .2rem
`;

const FoldBtn = styled.div`
display: flex;
justify-content: center;
align-items: center;
font-size: .24rem;
font-family: PingFang SC;
font-weight: normal;
color: rgba(255,255,255,1);
border-radius: 43px;
width: .9rem;
height: .4rem;
background: linear-gradient(91.53deg, rgba(255,69,113,1) 0%,rgba(250,44,25,1) 100%);
`;

const FoldTitleText = styled.div`
color:rgba(38,38,38,1);
font-size: .26rem;
font-family: PingFang SC;
font-weight: 500;
`;

const FoldTitleNum = styled.div`
margin-top: .1rem;
display:inline;
font-size: .24rem;
color: ${props => props.isNum ? '#FA2C19' : ''};
`;

const DividerLine = styled.div`
display: flex;
justify-content: center;
align-items: center;
padding: .2rem;
position: relative;
font-size: .24rem;
color: rgba(38,38,38,0.6);
background-color: #fff;
z-index: 1;

&::before {
  content: '';
  position: absolute;
  top: 50%;
  left: .2rem;
  right: .2rem;
  height: 1px;
  background: linear-gradient(to right, 
    rgba(38,38,38,0) 0%, 
    rgba(38,38,38,0.15) 20%, 
    rgba(38,38,38,0.3) 50%, 
    rgba(38,38,38,0.15) 80%, 
    rgba(38,38,38,0) 100%);
  z-index: -1;
}

span {
  background-color: #fff;
  padding: 0 .2rem;
  position: relative;
  z-index: 2;
}
`;

const ImageComtainer = styled.div`
position: relative;
width: 3.12rem;
height: 2.1rem;
margin-right: .2rem;
overflow: hidden;
img {
width: 100%;
height: 100%;
}
`;

const ImageTagContainer = styled.div`
position: absolute;
display: flex;
`;

const ImageTag = styled.div`
padding: 3px 5px;
background-color: ${props => props.bgColor};
font-size: .2rem;
color: ${props => props.color};;
`;

const InfoComtainer = styled.div`
flex: 1;
display: flex;
flex-direction: column;
justify-content: space-between;
`;

const InfoTitle = styled.div`
font-size: .24rem;
line-height: .34rem;
overflow:hidden;
text-overflow:ellipsis;
display:-webkit-box;
-webkit-line-clamp:2; 
-webkit-box-orient:vertical;
`;

const InfoPrice = styled.div`
display: flex;
flex-direction: row;
align-items: flex-end;
`;

const InfoPriceTag = styled.div`
font-size: .24rem;
color: #848689;
`;

const InfoPriceNum = styled.div`
font-size: .32rem;
color: ${props => props.color};
font-weight: 600;
letter-spacing: .01rem;
`;

const InfoDetail = styled.div`
display: flex;
flex-direction: row;
align-items: center;
font-size: .24rem;
color: #858689;
`;

const InfoDetailVisit = styled.div`
padding-right: 0.18rem;
`;

const InfoDetailLine = styled.div`
background-color:#858689;
width: .02rem;
height: .18rem;
`;

const InfoDetailLoc = styled.div`
background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAbCAIAAAAcf1OxAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3JpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDowZGRmM2VhMi0wNTAwLTRiYWMtOTY3My05ZWFlNmY5OGMyNjAiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6QUI1QzEwM0U2NkVCMTFFN0JFOTlFMjQ3NDQzN0Y2NDIiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6QUI1QzEwM0Q2NkVCMTFFN0JFOTlFMjQ3NDQzN0Y2NDIiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUuNSAoTWFjaW50b3NoKSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjMwMDkzN0EyNTk4NjExRTdBRjUyOTcwNjg5MEQwRkQzIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjMwMDkzN0EzNTk4NjExRTdBRjUyOTcwNjg5MEQwRkQzIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+vG/l4AAAAdpJREFUeNqUVdmqwkAM7cSquCPuWgS3B///UxREBMEXF1TEfdd7ekd6x0yrvQGxpjmZk+RkFM/n03i3x+OxXq83m83pdLrf76ZpRiKRVCqVSCSEECxYqHg8T6fT8Xh8vV4NzcLhsGVZuVzOHQ9Mv9/f7XbGR0un061Wi4je8LfbrdvtgrDhw1BIu92WKV5pBoOBTzBsu92ORiP5bOKzXC7RMBaUTCaz2SxqRt7ZbHY4HNS38KAR8Xjc5t/pdPb7vfra+jW1r8PhcD6fqzGZTMZuxPl8ZmCcrILtJglRr9fBRXWuVivkJQaGsQk5KVAOkwmKosvlwkKDwaBr23Q/Rk66pI7Hoyte9wNL0WiUeSFByJY5QXOxWDAnsIQZMGLoKISoShgj7PV6LClUBKA9P4hhMpmw3JAXdkbOH+rQ16xWqxUKBVs/xWIRnFkE2osJeUkQJ8sxkVysfD5v/MdKpdKb/iuVSiAQ8AnGeaD8KlN+hUKhcrnsE1+tVp39JZUS7pmvYDQVyv9rs9pwiPwzWI8hNlKnMC/mbItIj/CqAsz17KQzbDab+lLgFm40Gi4V6a5YLAYWzAkwZuQLL2eBe9br53e8PFC2ypWO+/8HM1zquJ0wFEctuv0IMAA3FtalP5LfdwAAAABJRU5ErkJggg==) no-repeat .1rem center;
background-size: .14rem .18rem;
padding-left: 0.3rem;
`;

const InfoTime = styled.div`
display: flex;
flex-direction: row;
min-width: 3.7rem;
width: auto;
height: .36rem;
line-height: .36rem;
background-color: ${props => props.bgColor};
`;

const InfoTimeTag = styled.div`
font-size: .26rem;
width: 1.18rem;
height: 100%;
border-bottom-right-radius: .18rem;
border-top-right-radius: .18rem;
text-align:center;
background-color: ${props => props.bgColor};
color: #fff;
`;

const InfoTimeDesc = styled.div`
color: #000;
font-size: .24rem;
padding: 0 .14rem;
background-color: ${props => props.bgColor};
white-space: nowrap;
overflow: visible;
flex: 1;
.cur-time-cutdown {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  .number {
  display: inline-block;
  width: .32rem;
  text-align:center;
	font-family: JDZhengHei-01-Regular;
	font-size: 0.24rem;
	line-height: 0.24rem;
	color: #e13030;
  }
  .font {
   display: inline-block;
   margin-right: .02rem;
  font-family: PingFangHK-Light;
	font-size: 0.18rem;
	line-height: 0.18rem;
	color: #121212;
  }
}

.pre-time-cutdown {
  .number {
  display: inline-block;
  text-align:center;
	font-family: JDZhengHei-01-Regular;
	font-size: 0.26rem;
	line-height: 0.26rem;
	color: #479e91;
  }
  .font {
   display: inline-block;
  font-family: PingFangHK-Light;
	font-size: 0.2rem;
	line-height: 0.2rem;
	color: #121212;
  }
}

.end-time-cutdown {
  .number {
  display: inline-block;
  text-align:center;
	font-family: JDZhengHei-01-Regular;
	font-size: 0.26rem;
	line-height: 0.26rem;
	color: #5a5a5a;
  }
  .font {
   display: inline-block;
  font-family: PingFangHK-Light;
	font-size: 0.2rem;
	line-height: 0.2rem;
	color: #121212;
  }
}
`;

export {
  ItemContainerBody,
  ItemContainer,
  ImageComtainer,
  ImageTagContainer,
  ImageTag,
  InfoComtainer,
  InfoTitle,
  InfoPrice,
  InfoPriceTag,
  InfoPriceNum,
  InfoDetail,
  InfoDetailVisit,
  InfoDetailLine,
  InfoDetailLoc,
  InfoTime,
  InfoTimeTag,
  InfoTimeDesc,
  FoldComtainer,
  FoldTitleComtainer,
  FoldMoreTitleComtainer,
  FoldTitleText,
  FoldTitleNum,
  FoldImgComtainer,
  FoldMoreContainer,
  FoldBtn,
  DividerLine
};
